import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap";

import KpiTile from "../../../../components/admin/KpiTile";
import PageHeader from "../../../../components/admin/PageHeader";
// Hooks
import useRefunds from "../../../../components/refunds/hooks/useRefunds";
// Components
import RefundsTableCard from "../../../../components/refunds/RefundsTableCard";

const Refunds: React.FC = () => {
  const { t } = useTranslation("dashboard", { keyPrefix: "adminPages.refunds" });
  const {
    refunds,
    isLoading: isLoadingRefunds,
    ...refundsProps
  } = useRefunds({
    filters: {},
    sort: { createdAt: "down" },
    pagination: { page: 1, pageSize: 10 },
  });

  return (
    <Container className="mt-4" fluid>
      <PageHeader title={t("title")} subtitle={t("totalDescription")} />
      <Row className="mb-3" style={{ rowGap: 12 }}>
        <Col xs={12} sm={6} xl={3}>
          <KpiTile
            label={t("totalRefunds")}
            value={refundsProps?.pagination?.total ?? 0}
            detail={t("totalDescription")}
            icon="fas fa-undo"
            isLoading={isLoadingRefunds && !refundsProps?.pagination?.total}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <RefundsTableCard
            {...refundsProps}
            title={t("realizedRefunds")}
            filtersToShow={["user"]}
            columnsToShow={["user"]}
            refunds={refunds}
            isLoading={isLoadingRefunds}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Refunds;
